
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/PartnerWithUs",
      function () {
        return require("private-next-pages/PartnerWithUs/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/PartnerWithUs"])
      });
    }
  